module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 pt-5"
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "text-center mt-3 w-100 mb-5 pb-5",
    staticStyle: {
      "line-height": "300%"
    }
  }, [_vm._v(_vm._s(_vm.description))])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-none d-sm-block col-sm-4 mt-5 pt-5"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/pic_plant.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-none d-sm-block col-sm-4 mt-5 pt-5"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/pic_plant.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64bd2f74!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Teacher/EmptyPage.vue
// module id = 792
// module chunks = 3